import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=2b7bc58c&"
var script = {}
import style0 from "@/assets/sass/index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports